module.exports = __webpack_public_path__ + "5b51492c35146c0240a7a7a68e993659.MP3";